import style from './Map.module.css'
import {ReactComponent as Close} from '../../Assets/icons/close.svg'
import { Link } from 'react-router-dom'
import { useMemo } from 'react';

export default function MapModal({item, setStore }){
    
    console.log(item);
    const url =  useMemo(() => item.cable_url ? item.cable_url : '')

    return <div className={style.modal__container}>
        <button className={style.close} onClick={() => setStore(null)}><Close/></button>
        <h3>{item.marketplace_name}</h3>
        <p>{item.address}</p>
        {url && <p onClick={() => window.open(url, '_blank')} className={style.link}>Ссылка на товар</p>}
    </div>;

  
}